import { render, staticRenderFns } from "./ClassroomShow.vue?vue&type=template&id=d7d32d86&scoped=true&"
import script from "./ClassroomShow.vue?vue&type=script&lang=ts&"
export * from "./ClassroomShow.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomShow.vue?vue&type=style&index=0&id=d7d32d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d32d86",
  null
  
)

export default component.exports